import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { SubscriptionMenuDto } from '../../../models/subscription/subscription-menu.dto';
import { API_BASE_URL } from '../../user-favorites.service';

@Injectable({ providedIn: 'root' })
export class SubscriptionMenuService {
  private readonly API_PATH = '/subscription/menu';
  private readonly API_BASE_URL: string;
  private cache = new Map<string, Observable<SubscriptionMenuDto>>();

  constructor(
    private http: HttpClient,
    @Optional() @Inject(API_BASE_URL) apiBaseUrl?: string
  ) {
    this.API_BASE_URL = apiBaseUrl || this.getApiBaseUrl();
  }

  private getApiBaseUrl(): string {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('api_base_url');
      if (stored) return stored;
    }
    return 'http://localhost:5000/v1';
  }

  getMenu(tenantId: string, userId: string): Observable<SubscriptionMenuDto> {
    const url = `${this.API_BASE_URL}${this.API_PATH}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'tenant_id': tenantId,
      'user_id': userId
    });
    return this.http.get<SubscriptionMenuDto>(url, { headers }).pipe(
      catchError(err => {
        console.error('Error loading subscription menu:', err);
        return of({
          tenantId,
          userId,
          subscription: { status: 'error', products: [] },
          modules: [],
          userFavorites: []
        });
      })
    );
  }

  sendContactInquiry(payload: { name: string; email: string; company: string; productCode: string; productName: string; message: string }): Observable<any> {
    const url = `${this.API_BASE_URL}/subscription/contact-inquiry`;
    return this.http.post<any>(url, payload);
  }

  clearCache(tenantId?: string): void {
    if (tenantId) {
      Array.from(this.cache.keys())
        .filter(key => key.startsWith(`${tenantId}:`))
        .forEach(key => this.cache.delete(key));
    } else {
      this.cache.clear();
    }
  }
}
